// jQueryプラグイン
export function newsFunc() {
  let newsTop = $('#newsTop').length;

  let resizecheck = $('#responsibleCheck').width();
  
  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(newsTop){

    let topicsCategoryList = $('.topicsCategoryList .activeSp');
    
    $(window).on('resize', function () {
      resizecheck = $('#responsibleCheck').width();

      //アコーディオン初期化
      if (resizecheck == '2') {
        topicsCategoryList.next('dd').css('display','none');
      } else if (resizecheck == '1') {
        if (topicsCategoryList.hasClass('categoryOpen')) {
          topicsCategoryList.removeClass('categoryOpen');
        }
        topicsCategoryList.next('dd').css('display','block');
      }
    });

    //アコーディオン初期化
    if (resizecheck == '2') {
      topicsCategoryList.next('dd').css('display','none');
    } else if (resizecheck == '1') { 
      if (topicsCategoryList.hasClass('categoryOpen')) {
        topicsCategoryList.removeClass('categoryOpen');
      }
      topicsCategoryList.next('dd').css('display','block');
    }

    let topicsArchivesList = $('.topicsArchivesList .archivesBtn');
    let topicsFlg = 0;
    topicsArchivesList.on('click', function () {
      if (resizecheck == '2') {
        $(this).stop().toggleClass('open');
        $(this).next().stop().slideToggle(500);
      }
    });

    //マウスを乗せたら発動
    $('#topicsArchivesList').hover(function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500)
        topicsArchivesList.stop().addClass('open');
        //ここにはマウスを離したときの動作を記述
      }
    }, function () {
      if (resizecheck == '1') {
        $(this).find('dd').stop().slideToggle(500);
        topicsArchivesList.stop().removeClass('open');
        //ここにはマウスを離したときの動作を記述
      }

    });

    topicsCategoryList.on('click', function () {
      $(this).stop().toggleClass('categoryOpen');
      $(this).next().stop().slideToggle(500);
    });

    topicsCategoryList.on({
      'mouseover': function () {
        if (responsibleCheck == '1') {
          topicsFlg = 1;
          $(this).toggleClass('categoryOpen');
          $(this).next().stop().slideToggle(500);
        }
      }
    });
  }
}